// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-2y1NE","content":"content-2YnqD","icon":"icon-23vil","link":"link-2ep7t"};